import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComingSoonIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "Coming soon",
			children: [
				/* @__PURE__ */ _jsx("g", {
					id: "Group 300",
					children: /* @__PURE__ */ _jsx("rect", {
						id: "Rectangle 3464110",
						width: 200,
						height: 140,
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1125",
					d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse 592",
					cx: 89.6406,
					cy: 120.66,
					r: 6,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse 593",
					cx: 40.6406,
					cy: 35.6602,
					r: 8,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group 631663",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M102.777 57.3691C102.931 59.2821 104.601 60.7033 106.514 60.5493L111.702 60.1315C113.615 59.9775 115.036 58.3075 114.882 56.3944C114.728 54.4813 113.058 53.0601 111.145 53.2142L105.957 53.6319C104.044 53.7859 102.623 55.456 102.777 57.3691ZM109.121 36.9942C107.879 38.454 108.055 40.6481 109.515 41.8904L113.252 45.0706C114.712 46.3128 116.906 46.1362 118.149 44.6763C119.391 43.2165 119.214 41.0224 117.754 39.7801L114.017 36.5999C112.557 35.3577 110.363 35.5343 109.121 36.9942ZM111.906 71.581C110.664 73.0409 110.84 75.235 112.3 76.4772C113.76 77.7195 115.954 77.5428 117.196 76.083L120.376 72.3458C121.619 70.886 121.442 68.6919 119.982 67.4496C118.522 66.2074 116.328 66.384 115.086 67.8439L111.906 71.581ZM125.038 31.2089L125.456 36.3969C125.61 38.31 127.28 39.7311 129.193 39.5771C131.106 39.4231 132.527 37.753 132.373 35.8399L131.955 30.6519C131.801 28.7388 130.131 27.3177 128.218 27.4717C126.305 27.6257 124.884 29.2958 125.038 31.2089ZM128.519 74.4425L128.937 79.6305C129.091 81.5436 130.761 82.9647 132.674 82.8107C134.587 82.6567 136.008 80.9866 135.854 79.0735L135.437 73.8855C135.282 71.9724 133.612 70.5513 131.699 70.7053C129.786 70.8593 128.365 72.5294 128.519 74.4425ZM140.528 37.9465C139.285 39.4063 139.462 41.6004 140.922 42.8427C142.382 44.085 144.576 43.9083 145.818 42.4485L148.998 38.7113C150.241 37.2515 150.064 35.0574 148.604 33.8151C147.144 32.5728 144.95 32.7495 143.708 34.2093L140.528 37.9465ZM142.755 65.616C141.513 67.0758 141.69 69.2699 143.15 70.5122L146.887 73.6924C148.347 74.9347 150.541 74.758 151.783 73.2982C153.025 71.8384 152.849 69.6442 151.389 68.402L147.652 65.2218C146.192 63.9795 143.998 64.1562 142.755 65.616ZM146.01 53.888C146.164 55.8011 147.834 57.2223 149.747 57.0682L154.935 56.6505C156.849 56.4965 158.27 54.8264 158.116 52.9133C157.962 51.0003 156.292 49.5791 154.379 49.7331L149.19 50.1509C147.277 50.3049 145.856 51.9749 146.01 53.888Z",
						fill: "url(#paint0_linear_4673_11571)"
					}), /* @__PURE__ */ _jsxs("g", {
						id: "Group 631662",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Vector_2",
							d: "M48.2078 88.12L57.0055 105.619C58.2221 108.039 61.0941 108.982 63.4324 107.73C65.7179 106.506 66.6321 103.622 65.536 101.242C70.7076 100.155 75.859 99.0625 81.0306 97.9761L88.0809 96.491C92.6748 95.5231 97.282 94.5481 101.876 93.5802C104.226 93.0851 106.576 92.5901 108.926 92.095L133.442 86.8958L107.049 34.3979L56.5871 83.4418C55.3325 81.1464 52.5213 80.2573 50.2359 81.4812C47.8976 82.7335 46.9913 85.7002 48.2078 88.12Z",
							fill: "url(#paint1_linear_4673_11571)"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Vector_3",
							d: "M109.077 27.7578C106.739 29.01 105.832 31.9767 107.049 34.3965L133.442 86.8945C134.658 89.3144 137.53 90.2577 139.869 89.0054C142.207 87.7532 143.113 84.7865 141.897 82.3667L115.504 29.8687C114.287 27.4489 111.415 26.5056 109.077 27.7578ZM82.5413 103.048C86.1841 110.294 94.8202 113.13 101.822 109.381C108.004 106.07 110.854 98.7307 108.932 92.073L101.869 93.5652C103.202 97.0505 101.799 101.064 98.5227 102.819C95.0219 104.693 90.7039 103.275 88.8825 99.6522C88.3738 98.6405 88.1104 97.5495 88.0737 96.476L81.0235 97.9612C81.2236 99.6933 81.7165 101.407 82.5413 103.048Z",
							fill: "url(#paint2_linear_4673_11571)"
						})]
					})]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_4673_11571",
				x1: 128.218,
				y1: 27.4717,
				x2: 132.674,
				y2: 82.8107,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#80E8D6"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_4673_11571",
				x1: 73.2296,
				y1: 52.5093,
				x2: 100.96,
				y2: 104.291,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_4673_11571",
				x1: 85.826,
				y1: 40.2094,
				x2: 118.178,
				y2: 100.621,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgComingSoonIcon);
export { ForwardRef as ReactComponent };
